import "./Orders.scss";

import { formatDate } from "../Utils/HelperFunctions";
import { useEffect } from "react";
import { ucp_visualization_presentation } from "../CesiumUtils/Visualizations";
import { truncateName } from "../../../../utils/commonFunctions";

const OrderDescriptionBox = ({ headerElement, orderDescriptionBoxVisibility, ucpViewer }) => {
  useEffect(() => {
    let dataSourceName;
    switch (headerElement?.status?.state) {
      case 'Current':
        dataSourceName = 'Current_Order'
        break
      case 'Pending':
        dataSourceName = 'Pending_Order'
        break
      case 'Executed':
        dataSourceName = 'Executed_Order'
        break
      default:
        break
    }
    ucp_visualization_presentation().refresh_aoi_view(ucpViewer, dataSourceName)
    if (orderDescriptionBoxVisibility.display !== 'none') {
      ucp_visualization_presentation().zoom_into_selected_entity(ucpViewer, dataSourceName, `aoi_${headerElement?.spec?.geofeature?.features[0]?.id}`)
    }
  }, [orderDescriptionBoxVisibility])

  return (
    <div className="orderDescriptionBox" style={orderDescriptionBoxVisibility}>
      {headerElement?.status?.state !== "Delay" && (
        <>
          <div className="orderDescriptionBoxHeaderDiv">
            <div className="orderDescriptionBoxHeader">
              <div className="priorityIconDiv">
                {headerElement?.spec.attributes.priorityLane === 'Normal' && <img className="priorityIcon" src={require("../../assets/raw/Normal.svg").default} alt="" />}
                {headerElement?.spec.attributes.priorityLane === 'High' && <img className="priorityIcon" src={require("../../assets/raw/High.svg").default} alt="" />}
                {headerElement?.spec.attributes.priorityLane === 'ASAP' && <img className="priorityIcon" src={require("../../assets/raw/Asap.svg").default} alt="" />}
              </div>
              <div className="orderTitleName" title={headerElement?.spec?.name}>{truncateName(headerElement?.spec?.name)}</div>
            </div>
            {headerElement?.spec?.attributes.recurring && (
              <div style={{ position: "absolute", right: "10px" }}>
                <img className="pauseIcon recurringIcon" src={require("../../assets/raw/RecurringIcon.svg").default} alt="" />
              </div>
            )}
            {/* <div className="orderProgressDiv descBoxOrderProgressDiv">
              <CircularProgressBarComponent
                item={headerElement}
              >
              </CircularProgressBarComponent>
            </div> */}
          </div>
          {/* <div className="orderDescriptionBoxDatesDiv">
            <div className="orderDescriptionBoxDates">
              <div className="orderDescriptionBoxDatesTitle">{formatDate(headerElement.createdAt)}</div>
              <div className="orderDescriptionBoxDatesSubTitle">Start Time</div>
            </div>
            <div className="orderDescriptionBoxDates">
              <div className="orderDescriptionBoxDatesTitle">+ N days</div>
              <div className="orderDescriptionBoxDatesSubTitle">Estimated End Time</div>
            </div>
          </div> */}
          <div className="orderDescriptionBoxBodyDiv">
            <div className="orderDescriptionBoxHeaderDiv">
              <div className="orderDescriptionBoxBodyHeader">Order Details</div>
              <div className="orderDescriptionBoxBodyStatus">{headerElement?.status?.state}</div>
            </div>
            <div className="">
              {headerElement?.spec?.geofeature?.label && <div style={{ width: '100%', height: '20px' }}>
                <div className="orderDescriptionBoxLabel">AOI label</div>
                <div className="orderDescriptionBoxValue" title={headerElement?.spec?.name}>{truncateName(headerElement?.spec?.name)}</div>
              </div>
              }
              {headerElement?.spec?.attributes?.imagingSpectrum &&
                <div style={{ width: '100%', height: '20px' }}>
                  <div className="orderDescriptionBoxLabel">Image Spectrum</div>
                  <div className="orderDescriptionBoxValue">{headerElement?.spec?.attributes?.imagingSpectrum}</div>
                </div>
              }
              {headerElement?.spec?.attributes?.cloudCoverage && <div style={{ width: '100%', height: '20px' }}>
                <div className="orderDescriptionBoxLabel">Cloud Coverage</div>
                <div className="orderDescriptionBoxValue">{headerElement?.spec?.attributes?.cloudCoverage}</div>
              </div>
              }
              {headerElement?.spec?.attributes?.resolution && <div style={{ width: '100%', height: '20px' }}>
                <div className="orderDescriptionBoxLabel">Resolution</div>
                <div className="orderDescriptionBoxValue">{headerElement?.spec?.attributes?.resolution}</div>
              </div>
              }
              {headerElement?.createdAt && <div style={{ width: '100%', height: '20px' }}>
                <div className="orderDescriptionBoxLabel">Submitted Time</div>
                <div className="orderDescriptionBoxValue" title={formatDate(headerElement.createdAt)}>{formatDate(headerElement.createdAt)}</div>
              </div>
              }
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default OrderDescriptionBox;